import React, { useEffect, useState, useRef } from 'react';
import { Container, Card, Table, Dropdown, Form, Button } from 'react-bootstrap';
import { useAuth } from '../../Context/AuthContext';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import { useSearchParams, useParams } from 'react-router-dom';
import { BarChart, BarChart2, BarChart3, BarChart4 } from '../Chart/barChart';
import { PieChart } from '../Chart/pieChart';
import { DoughnutChart } from '../Chart/doughnutChart';
import Pagination from 'react-bootstrap/Pagination';
import {
  totalSales,
  useSrikandiUser,
  getNewSrikandi,
  srikandiAllSales,
  allSales,
  getRecruit,
  srikandiReinstateRetention,
  topSales,
  // retentionSrikandi,
  // reinstatementSrikandi,
  // recruitmentSrikandi,
} from '../../API';
import './index.css';
import {
  ISale,
  NewSrikandi,
  Recruit,
  // RecruitmentSrikandi,
  ReinstatementRetention,
  // ReinstatementSrikandi,
  // RetentionSrikandi,
  SESale,
  SalesSrikandi,
  SrikandiSale,
  TotalSale,
} from '../../@types';

const formatDate = (date: Date) => date.toISOString().slice(0, 10);

const formatParamDate = (date: Date) => date.toISOString().slice(0, 10).replaceAll('-', '');
const format = (date: string) => `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;

const serialiseSearchParams = (params: any) => {
  return Object.keys(params)
    .map((e) => `${e}=${params[e]}`)
    .join('&');
};
interface productSold {
  item: string;
  sku?: string;
  unit: number;
  totalSale: number;
  location: string;
}
const itemsPerPageReinstate = 10;
const maxVisiblePagesReinstate = 10;
const itemsPerPageRetention = 10;
const maxVisiblePagesRetention = 10;
const itemsPerPageNewSrikandiRetention = 10;
const maxVisiblePagesNewSrikandiRetention = 10;
export const Home = () => {
  const [isDateSelectorClosed, setIsDateSelectorClosed] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const start = searchParams.get('from');
  const end = searchParams.get('till');
  const startDate = start ? new Date(format(start)) : new Date();
  const endDate = end ? new Date(format(end)) : new Date();

  const [busy, setBusy] = useState(false);
  const [openProductSold, setOpenProductSold] = useState(false);
  const [openSrikandiRecruit, setOpenSrikandiRecruit] = useState(false);
  const [sales, setSales] = useState<TotalSale[]>([]);
  const [allSalesSrikadi, setAllSales] = useState<ISale[]>([]);
  const [newSrikandi, setNewSrikandi] = useState<NewSrikandi[]>([]);
  const [srikandiNotInSales, setSrikandiNotInSales] = useState<SalesSrikandi>();
  const [srikandiRecruit, setSrikandiRecruit] = useState<Recruit[]>([]);
  const [srikandiTop, setSrikandiTop] = useState<SrikandiSale[]>([]);
  const [srikandiEmasTop, setSrikandiEmasTop] = useState<SESale[]>([]);
  const [reinstateRetention, setSrikandiReinstateRetention] = useState<ReinstatementRetention>();
  // const [srikandiRetention, setSrikandiRetention] = useState<RetentionSrikandi[]>();
  // const [srikandiReinstatement, setSrikandiReinstatement] = useState<ReinstatementSrikandi[]>();
  // const [srikandiRecruitment, setSrikandiRecruitment] = useState<RecruitmentSrikandi[]>();
  const { user: currentUser, dbUser } = useAuth();
  const { userId } = useParams();
  const user = useSrikandiUser(userId || currentUser?.uid);
  const isSummary = window.location.pathname.includes('summary');
  const [totalOnline, setTotalOnline] = useState('');
  const [totalOutlet, setTotalOutlet] = useState('');
  const [grandTotal, setGrandTotal] = useState('');
  const [groupedData, setGroupedData] = useState({});
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterLocation, setFilter] = useState('');
  const tableProductUnitSoldCurrent = useRef<HTMLDivElement | null>(null);
  const tableSrikandiRecruitCurrent = useRef<HTMLDivElement | null>(null);

  const [currentPageRetention, setCurrentPageRetention] = useState(1);
  const [currentPageNewSrikandiRetention, setCurrentPageNewSrikandiRetention] = useState(1);
  const [currentPageReinstate, setCurrentPageReinstate] = useState(1);

  const indexOfLastItemReinstate = currentPageReinstate * itemsPerPageReinstate;
  const indexOfFirstItemReinstate = indexOfLastItemReinstate - itemsPerPageReinstate;
  const indexOfLastItemRetention = currentPageRetention * itemsPerPageRetention;
  const indexOfFirstItemRetention = indexOfLastItemRetention - itemsPerPageRetention;
  const indexOfLastItemNewSrikandiRetention =
    currentPageNewSrikandiRetention * itemsPerPageNewSrikandiRetention;
  const indexOfFirstItemNewSrikandiRetention =
    indexOfLastItemNewSrikandiRetention - itemsPerPageNewSrikandiRetention;
  const currentItemsReinstatement = reinstateRetention?.reinstateEmails.slice(
    indexOfFirstItemReinstate,
    indexOfLastItemReinstate,
  );
  const currentItemsRetention = reinstateRetention?.retentionEmails.slice(
    indexOfFirstItemRetention,
    indexOfLastItemRetention,
  );
  const currentItemsNewSrikandiRetention = reinstateRetention?.newRecruitSrikandi.slice(
    indexOfFirstItemNewSrikandiRetention,
    indexOfLastItemNewSrikandiRetention,
  );

  const totalPagesReinstate = Math.ceil(
    (reinstateRetention?.reinstateEmails.length as any) / itemsPerPageReinstate,
  );
  const totalPagesRetention = Math.ceil(
    (reinstateRetention?.retentionEmails.length as any) / itemsPerPageRetention,
  );
  const totalPagesNewSrikandiRetention = Math.ceil(
    (reinstateRetention?.newRecruitSrikandi.length as any) / itemsPerPageNewSrikandiRetention,
  );

  const handlePageChangeReinstate = (pageNumber: number) => {
    setCurrentPageReinstate(pageNumber);
  };
  const handlePageChangeRetention = (pageNumber: number) => {
    setCurrentPageRetention(pageNumber);
  };
  const handlePageChangeNewSrikandiRetention = (pageNumber: number) => {
    setCurrentPageNewSrikandiRetention(pageNumber);
  };

  useEffect(() => {
    if (!start || !end) {
      const params = {
        from: formatParamDate(new Date()),
        till: formatParamDate(new Date()),
      };
      setSearchParams(serialiseSearchParams(params));
    }
  }, [start, end]);

  const handleDatesChanged = (dates: DateObject[]) => {
    const [start, end] = dates.map((e) => e?.toDate());
    if (start && end) {
      const params = {
        from: formatParamDate(start),
        till: formatParamDate(end),
      };
      setSearchParams(serialiseSearchParams(params));
    }
  };
  useEffect(() => {
    if (user && startDate && endDate && isDateSelectorClosed) {
      setBusy(true);
      // if has userid (from url params) query just individual sales, else group sales
      const getTotalSalesContainer = totalSales;
      const getNewSrikandiContainer = getNewSrikandi;
      const getSrikandiAllSales = srikandiAllSales;
      const getAllSaleContainer = allSales;
      const getSrikandiRecruit = getRecruit;
      const getSrikandiReinstateRetention = srikandiReinstateRetention;
      const getSrikandiTopSales = topSales;
      // const getSrikandiRetention = retentionSrikandi;
      // const getSrikandiReinstatement = reinstatementSrikandi;
      // const getSrikandiRecruitment = recruitmentSrikandi;

      getTotalSalesContainer(formatDate(startDate), formatDate(endDate)).then((data) => {
        setBusy(false);
        setSales(data);
        const onlineSale = data.reduce((acc, item) => {
          const onlineValue = parseFloat(item.Online.replace(/,/g, ''));
          if (!isNaN(onlineValue)) {
            return acc + onlineValue;
          } else {
            return acc;
          }
        }, 0);
        const outletSale = data.reduce((acc, item) => {
          const outletValue = parseFloat(item.Outlet.replace(/,/g, ''));
          if (!isNaN(outletValue)) {
            return acc + outletValue;
          } else {
            return acc;
          }
        }, 0);
        const formattedTotalOnline = onlineSale.toLocaleString('en-MY', {
          style: 'currency',
          currency: 'MYR',
          minimumFractionDigits: 2,
        });
        const formattedTotalOutlet = outletSale.toLocaleString('en-MY', {
          style: 'currency',
          currency: 'MYR',
          minimumFractionDigits: 2,
        });
        const formattedGrandTotal = (onlineSale + outletSale).toLocaleString('en-MY', {
          style: 'currency',
          currency: 'MYR',
          minimumFractionDigits: 2,
        });
        setTotalOnline(formattedTotalOnline);
        setTotalOutlet(formattedTotalOutlet);
        setGrandTotal(formattedGrandTotal);
      });
      getNewSrikandiContainer(formatDate(startDate), formatDate(endDate)).then((data) => {
        setBusy(false);
        setNewSrikandi(data);

        const groupedData: any = {};
        data.forEach((item) => {
          const date = item.registered_at;
          if (!groupedData[date]) {
            groupedData[date] = [];
          }
          groupedData[date].push(item);
        });

        setGroupedData(groupedData);
      });
      getSrikandiAllSales(formatDate(startDate), formatDate(endDate)).then((data) => {
        setBusy(false);
        setSrikandiNotInSales(data);
      });
      // getSrikandiRetention().then((data) => {
      //   setBusy(false);
      //   setSrikandiRetention(data);
      // });
      // getSrikandiReinstatement().then((data) => {
      //   setBusy(false);
      //   setSrikandiReinstatement(data);
      // });
      // getSrikandiRecruitment().then((data) => {
      //   setBusy(false);
      //   setSrikandiRecruitment(data);
      // });
      getAllSaleContainer(formatDate(startDate), formatDate(endDate)).then((data) => {
        setBusy(false);
        setAllSales(data);
      });
      getSrikandiRecruit(formatDate(startDate), formatDate(endDate)).then((data) => {
        setBusy(false);
        setSrikandiRecruit(data);
      });
      getSrikandiReinstateRetention().then((data) => {
        setBusy(false);
        setSrikandiReinstateRetention(data);
      });
      getSrikandiTopSales(formatDate(startDate), formatDate(endDate)).then((data) => {
        setBusy(false);
        setSrikandiTop(data.srikandiSale);
        setSrikandiEmasTop(data.SESale);
      });
    }
  }, [userId, user, start, end, isDateSelectorClosed, isSummary]);
  // const noSrikandiRetention = srikandiRetention?.length
  // const noSrikandiReinstatement = srikandiReinstatement?.length
  // const noSrikandiRecruitment = srikandiRecruitment?.length
  // let totalRetentionRevenue: number = 0;
  // let totalReinstatementRevenue: number = 0;
  // let totalRecruitmentRevenue: number = 0;

  // srikandiRetention?.map((e) => {
  //   totalRetentionRevenue+=e.totalSale;
  // })
  // srikandiReinstatement?.map((e) => {
  //   totalReinstatementRevenue+=e.totalSale;
  // })
  // srikandiRecruitment?.map((e) => {
  //   totalRecruitmentRevenue+=e.totalSale;
  // })
  // const formattedTotalRetentionRevenue = totalRetentionRevenue.toLocaleString('en-MY', {
  //   style: 'currency',
  //   currency: 'MYR',
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2,
  // });
  // const formattedTotalReinstatementRevenue = totalReinstatementRevenue.toLocaleString('en-MY', {
  //   style: 'currency',
  //   currency: 'MYR',
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2,
  // });
  // const formattedTotalRecruitmentRevenue = totalRecruitmentRevenue.toLocaleString('en-MY', {
  //   style: 'currency',
  //   currency: 'MYR',
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2,
  // });

  const productUnitSold = (sales: ISale[]) => {
    return sales.reduce((acc, curr) => {
      // Check if the product already exists in the accumulator
      const existingProduct = acc.find((product) => product.item === curr.order_item_title);

      if (existingProduct) {
        // If the product exists, increment the unit count
        existingProduct.unit += 1;
        existingProduct.totalSale += parseFloat(curr.order_item_sale);
      } else {
        // If the product doesn't exist, add it to the accumulator with unit 1
        acc.push({
          item: curr.order_item_title,
          sku: curr.order_item_sku,
          unit: 1,
          totalSale: parseFloat(curr.order_item_sale),
          location: curr.type === 'woocommerce' ? 'Butik' : 'Website',
        });
      }

      return acc;
    }, [] as productSold[]);
  };

  let unitSold;
  unitSold = productUnitSold(allSalesSrikadi);

  unitSold.sort((a, b) => b.unit - a.unit);
  srikandiRecruit.sort((a, b) => b.totalChildren - a.totalChildren);
  srikandiTop.sort((a, b) => b.total_sale - a.total_sale);
  srikandiEmasTop.sort((a, b) => b.total_sale - a.total_sale);

  const getOrderStatus = (sale: ISale) => {
    if (sale.cancelled_at) {
      return 'Cancelled';
    }
    if (sale.fulfilled_at) {
      return 'Fulfilled';
    }
    return 'Paid';
  };

  const groupSales = (sales: ISale[]) => {
    const grouped = sales.reduce((acc, curr) => {
      // if(!curr.event_name){
      acc[curr.order_id] = (acc[curr.order_id] || []).concat(curr);
      // }
      return acc;
    }, {} as { [orderId: string]: ISale[] });
    return Object.keys(grouped).map((e) => {
      const items = grouped[e];
      return {
        orderId: items[0].order_name || e,
        source: items[0].type,
        email: items[0].customer_email,
        itemCount: items.length,
        orderDate: items[0].order_datetime,
        orderSales: parseFloat(items[0].order_total_sale),
        orderCurrency: items[0].order_currency,
        orderStatus: getOrderStatus(items[0]),
        items,
      };
    });
  };

  const groupedSales = groupSales(allSalesSrikadi);

  const totalGroupSale = groupedSales
    .reduce((acc, curr) => (curr.orderStatus !== 'Cancelled' ? acc + curr.orderSales : acc), 0)
    .toFixed(2);

  const seeMoreProductSold = () => {
    setOpenProductSold(true);
    if (tableProductUnitSoldCurrent.current) {
      tableProductUnitSoldCurrent.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const seeMoreSrikandiRectuiter = () => {
    setOpenSrikandiRecruit(true);
    if (tableSrikandiRecruitCurrent.current) {
      tableSrikandiRecruitCurrent.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const basketSize = (parseFloat(totalGroupSale) / groupedSales.length).toFixed(2);

  const handleFilter = () => {
    setFilter((f) => {
      if (f === '') return '↑';
      if (f === '↑') return '↓';
      if (f === '↓') return '';
      return '';
    });
  };

  const handleDropdownChange = (item: any) => {
    if (selectedItems.includes(item)) {
      setSelectedItems(selectedItems.filter((selectedItem) => selectedItem !== item));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const renderPaginationReinstate = () => {
    const pages = [];
    const startPage = Math.max(1, currentPageReinstate - Math.floor(maxVisiblePagesReinstate / 2));
    const endPage = Math.min(totalPagesReinstate, startPage + maxVisiblePagesReinstate - 1);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Pagination.Item
          key={i}
          active={currentPageReinstate === i}
          onClick={() => handlePageChangeReinstate(i)}
        >
          {i}
        </Pagination.Item>,
      );
    }

    if (startPage > 1) {
      pages.unshift(<Pagination.Ellipsis key="ellipsis-start" />);
    }

    if (endPage < totalPagesReinstate) {
      pages.push(<Pagination.Ellipsis key="ellipsis-end" />);
    }

    return pages;
  };

  const renderPaginationRetention = () => {
    const pages = [];
    const startPage = Math.max(1, currentPageRetention - Math.floor(maxVisiblePagesRetention / 2));
    const endPage = Math.min(totalPagesRetention, startPage + maxVisiblePagesRetention - 1);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Pagination.Item
          key={i}
          active={currentPageRetention === i}
          onClick={() => handlePageChangeRetention(i)}
        >
          {i}
        </Pagination.Item>,
      );
    }

    if (startPage > 1) {
      pages.unshift(<Pagination.Ellipsis key="ellipsis-start" />);
    }

    if (endPage < totalPagesRetention) {
      pages.push(<Pagination.Ellipsis key="ellipsis-end" />);
    }

    return pages;
  };
  const renderPaginationNewSrikandiRetention = () => {
    const pages = [];
    const startPage = Math.max(
      1,
      currentPageNewSrikandiRetention - Math.floor(maxVisiblePagesNewSrikandiRetention / 2),
    );
    const endPage = Math.min(
      totalPagesNewSrikandiRetention,
      startPage + maxVisiblePagesNewSrikandiRetention - 1,
    );

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Pagination.Item
          key={i}
          active={currentPageNewSrikandiRetention === i}
          onClick={() => handlePageChangeNewSrikandiRetention(i)}
        >
          {i}
        </Pagination.Item>,
      );
    }

    if (startPage > 1) {
      pages.unshift(<Pagination.Ellipsis key="ellipsis-start" />);
    }

    if (endPage < totalPagesNewSrikandiRetention) {
      pages.push(<Pagination.Ellipsis key="ellipsis-end" />);
    }

    return pages;
  };

  const handleDownload = () => {
    console.log('download sales report');
    // http://127.0.0.1:5001/sk-srikandi/asia-southeast1/query-topProductReport
    if (
      window.confirm(
        `Download selected date (${
          formatDate(startDate) + ' until ' + formatDate(endDate)
        }) report?`,
      )
    ) {
      window.open(
        `https://asia-southeast1-sk-srikandi.cloudfunctions.net/query-topProductReport?from=${formatDate(
          startDate,
        )}&till=${formatDate(endDate)}&secret=QAoL5xN6Up`,
        '_blank',
      );
    }
  };
  return (
    <Container>
      <h2 className="header">SK Srikandi Backend</h2>
      <h4>Welcome {user ? user.email : ''}!</h4>
      {dbUser?.role === 'admin' ? (
        <div>
          <div className=" centerItem">
            <br></br>
            <b className="smallTitle">Date interval</b>
            <br></br>
            <b className="text">
              {' '}
              <DatePicker
                onOpen={() => setIsDateSelectorClosed(false)}
                onClose={() => setIsDateSelectorClosed(true)}
                range
                value={[startDate, endDate]}
                onChange={handleDatesChanged}
                style={{
                  border: '1px solid var(--primaryColor)',
                  height: '30px',
                  width: '200px',
                  padding: '2px 20px',
                }}
              />
            </b>
            <br></br>
            <br></br>
            <div className="card-item">
              <Card style={{ width: '18rem' }}>
                <Card.Body>
                  <Card.Title>{grandTotal}</Card.Title>
                  <Card.Text className="card-text">Total Sale</Card.Text>
                </Card.Body>
              </Card>
              <Card style={{ width: '18rem' }}>
                <Card.Body>
                  <Card.Title>{totalOnline}</Card.Title>
                  <Card.Text className="card-text">Website Sale</Card.Text>
                </Card.Body>
              </Card>
              <Card style={{ width: '18rem' }}>
                <Card.Body>
                  <Card.Title>{totalOutlet}</Card.Title>
                  <Card.Text className="card-text">Butiksite Sale</Card.Text>
                </Card.Body>
              </Card>
            </div>
            <div className="card-item">
              <Card style={{ width: '18rem' }}>
                <Card.Body>
                  <Card.Title>
                    {srikandiNotInSales ? srikandiNotInSales.inactiveSrikandi.length : 0} srikandi
                  </Card.Title>
                  <Card.Text className="card-text">Total Inactive Srikandi</Card.Text>
                </Card.Body>
              </Card>
              <Card style={{ width: '18rem' }}>
                <Card.Body>
                  <Card.Title>
                    {srikandiNotInSales ? srikandiNotInSales.activeSrikandi.length : 0} srikandi
                  </Card.Title>
                  <Card.Text className="card-text">Total Active Srikandi</Card.Text>
                </Card.Body>
              </Card>
              <Card style={{ width: '18rem' }}>
                <Card.Body>
                  <Card.Title>{newSrikandi.length > 0 ? newSrikandi.length : 0}</Card.Title>
                  <Card.Text className="card-text">Total New Srikandi</Card.Text>
                </Card.Body>
              </Card>
              <Card style={{ width: '18rem' }}>
                <Card.Body>
                  <Card.Title>{'RM ' + basketSize}</Card.Title>
                  <Card.Text className="card-text">Basket Size</Card.Text>
                </Card.Body>
              </Card>
            </div>
          </div>
          <br></br>
          <br></br>
          {/* chart for sales and new srikandi */}
          <div className="chart-container">
            <Card className="card-chart">
              <BarChart
                text={'Sales Bar Chart'}
                chartLabels={['Website', 'Butiksite']}
                chartData={sales}
              />
            </Card>
            <Card className="card-chart">
              <BarChart2
                text={'New Srikandi Bar Chart'}
                chartLabels={['Srikandi']}
                chartData={groupedData}
              />
            </Card>
          </div>
          <br></br>
          <br></br>
          {/* chart for top sales srikandi and SE*/}
          <div className="chart-container">
            <Card className="card-chart">
              <BarChart3
                text={'Top Sales Srikandi'}
                chartLabels={['Srikandi']}
                chartData={srikandiTop.slice(0, 10)}
              />
            </Card>
            <Card className="card-chart">
              <BarChart4
                text={'Top Sales Srikandi Emas'}
                chartLabels={['Srikandi Emas']}
                chartData={srikandiEmasTop.slice(0, 10)}
              />
            </Card>
          </div>
          <br></br>
          <br></br>
          {/* chart for top sold and top srikandi recruit */}
          <div className="chart-container" style={{ height: '20rem' }}>
            <Card className="card-chart">
              <PieChart
                labelValue={unitSold.filter(
                  (e) =>
                    e.item !== 'Malar Retail Bag' &&
                    e.item !== 'Ottoman Lite Gift Box' &&
                    e.item !== 'Lumerek Net Bag',
                )}
              />
              <div className="see-more-text" onClick={seeMoreProductSold}>
                See more
              </div>
            </Card>
            <Card className="card-chart">
              <DoughnutChart labelValue={srikandiRecruit} />
              <div className="see-more-text" onClick={seeMoreSrikandiRectuiter}>
                See more
              </div>
            </Card>
          </div>
          <br></br>
          <br></br>
          {/* retention and reinstatement rate srikandi */}
          <div>
            <Card>
              <Card.Body>
                <Card.Title>
                  Retention and Reinstatement{' '}
                  <small style={{ fontSize: '15px' }}>for 3 month</small>
                </Card.Title>
                <div className=" centerItem">
                  <div className="card-item">
                    <Card style={{ width: '18rem' }}>
                      <Card.Body>
                        <Card.Title>
                          {reinstateRetention?.retentionValue
                            ? reinstateRetention?.retentionValue + '%'
                            : 0 + '%'}
                        </Card.Title>
                        <Card.Text className="card-text">Srikandi Retention Rate</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card style={{ width: '18rem' }}>
                      <Card.Body>
                        <Card.Title>
                          {reinstateRetention?.reinstatementValue
                            ? reinstateRetention?.reinstatementValue + '%'
                            : 0 + '%'}
                        </Card.Title>
                        <Card.Text className="card-text">Srikandi Reinstatement Rate</Card.Text>
                      </Card.Body>
                    </Card>
                    <Card style={{ width: '18rem' }}>
                      <Card.Body>
                        <Card.Title>
                          {reinstateRetention?.reinstatementValue
                            ? reinstateRetention?.reinstateEmails.length +
                              reinstateRetention?.retentionEmails.length
                            : 0}
                        </Card.Title>
                        <Card.Text className="card-text">Total Active Srikandi</Card.Text>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
                <br></br>

                <div className="table-container">
                  <Table striped bordered hover className="table">
                    <thead>
                      <tr>
                        <th style={{ color: 'black' }} colSpan={2}>
                          Retention Customer
                        </th>
                      </tr>
                      <tr>
                        <th style={{ color: 'black' }}>No</th>
                        <th style={{ color: 'black' }}>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reinstateRetention ? (
                        currentItemsRetention?.map((value, index) => (
                          <tr key={index}>
                            <td>{index + 1 + indexOfFirstItemRetention}</td>
                            <td>{value}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2}>{'No data'}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <Pagination>{renderPaginationRetention()}</Pagination>
                </div>
                <div className="table-container">
                  <Table striped bordered hover className="table">
                    <thead>
                      <tr>
                        <th style={{ color: 'black' }} colSpan={2}>
                          Reinstatement Customer
                        </th>
                      </tr>
                      <tr>
                        <th style={{ color: 'black' }}>No</th>
                        <th style={{ color: 'black' }}>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reinstateRetention ? (
                        currentItemsReinstatement?.map((value, index) => (
                          <tr key={index}>
                            <td>{index + 1 + indexOfFirstItemReinstate}</td>
                            <td>{value}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2}>{'No data'}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <Pagination>{renderPaginationReinstate()}</Pagination>
                </div>
                {/* <div className="table-container">
                  <Table striped bordered hover className="table">
                    <thead>
                      <tr>
                        <th style={{ color: 'black' }} colSpan={2}>New Srikandi</th>
                      </tr>
                      <tr>
                        <th style={{ color: 'black' }}>No</th>
                        <th style={{ color: 'black' }}>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reinstateRetention ? (
                        currentItemsNewSrikandiRetention?.map((value, index) => (
                          <tr key={index}>
                            <td>{index + 1 + indexOfFirstItemNewSrikandiRetention}</td>
                            <td>{value}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2}>{'No data'}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <Pagination>{renderPaginationNewSrikandiRetention()}</Pagination>
                </div> */}
              </Card.Body>
            </Card>
          </div>
          <br></br>
          <br></br>

          <div>
            <Card>
              <Card.Body>
                <div className="table-container">
                  <Table striped bordered hover className="table">
                    <thead>
                      <tr>
                        <th style={{ color: 'black' }} colSpan={2}>
                          New Srikandi
                        </th>
                      </tr>
                      <tr>
                        <th style={{ color: 'black' }}>No</th>
                        <th style={{ color: 'black' }}>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reinstateRetention ? (
                        currentItemsNewSrikandiRetention?.map((value, index) => (
                          <tr key={index}>
                            <td>{index + 1 + indexOfFirstItemNewSrikandiRetention}</td>
                            <td>{value}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={2}>{'No data'}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  <Pagination>{renderPaginationNewSrikandiRetention()}</Pagination>
                </div>
              </Card.Body>
            </Card>
          </div>
          <br></br>
          <br></br>
          {/* retention and reinstatement rate srikandi */}
          <div className="container mx-auto mt-8" style={{ paddingRight: '50%' }}>
            <Table striped bordered hover className="table">
              <thead>
                <tr>
                  <th className="py-2 px-4 border-b" style={{ background: 'transparent' }}></th>
                  <th className="py-2 px-4 border-b">No of Customers</th>
                  <th className="py-2 px-4 border-b">Revenue</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-gray-100">
                  <td className="py-2 px-4 border-b">Recruitment</td>
                  <td className="py-2 px-4 border-b">tbd</td>
                  <td className="py-2 px-4 border-b">tbd</td>
                  {/* <td className="py-2 px-4 border-b">{noSrikandiRecruitment}</td>
                  <td className="py-2 px-4 border-b">{formattedTotalRecruitmentRevenue}</td> */}
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">Retention</td>
                  <td className="py-2 px-4 border-b">tbd</td>
                  <td className="py-2 px-4 border-b">tbd</td>
                  {/* <td className="py-2 px-4 border-b">{noSrikandiRetention}</td>
                  <td className="py-2 px-4 border-b">{formattedTotalRetentionRevenue}</td> */}
                </tr>
                <tr className="bg-gray-100">
                  <td className="py-2 px-4 border-b">Reinstatement</td>
                  <td className="py-2 px-4 border-b">tbd</td>
                  <td className="py-2 px-4 border-b">tbd</td>
                  {/* <td className="py-2 px-4 border-b">{noSrikandiReinstatement}</td>
                  <td className="py-2 px-4 border-b">{formattedTotalReinstatementRevenue}</td> */}
                </tr>
              </tbody>
            </Table>
          </div>
          <small style={{ fontSize: '10px' }}>***Reinstatement for last 3 month</small><br></br>
          <small style={{ fontSize: '10px' }}>***Retention for last 1 month</small><br></br>
          <small style={{ fontSize: '10px' }}>***Recruitment for this month</small>
          {/* active count srikandi
          <div className="container mx-auto mt-8" style={{ paddingRight: '50%' }}>
            <Table striped bordered hover className="table">
              <thead>
                <tr>
                  <th className="py-2 px-4 border-b" style={{ background: 'transparent' }}></th>
                  <th className="py-2 px-4 border-b">Overall</th>
                  <th className="py-2 px-4 border-b">Active Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr className="bg-gray-100">
                  <td className="py-2 px-4 border-b">Srikandi</td>
                  <td className="py-2 px-4 border-b"></td>
                  <td className="py-2 px-4 border-b"></td>
                </tr>
                <tr>
                  <td className="py-2 px-4 border-b">SE</td>
                  <td className="py-2 px-4 border-b">{noSrikandiRetention}</td>
                  <td className="py-2 px-4 border-b">{formattedTotalRetentionRevenue}</td>
                </tr>
                <tr className="bg-gray-100">
                  <td className="py-2 px-4 border-b">SE VIP</td>
                  <td className="py-2 px-4 border-b"></td>
                  <td className="py-2 px-4 border-b"></td>
                </tr>
              </tbody>
            </Table>
          </div> */}
          <br></br>
          <br></br>
          {/* table for product unit sold */}
          {openProductSold ? (
            <div ref={tableProductUnitSoldCurrent} className="table-container">
              <Card>
                <Card.Body>
                  <div className="actions-container">
                    <Card.Title>Top Product Unit Sold</Card.Title>
                    <Button variant="outline-dark" onClick={handleDownload}>
                      Download Report
                    </Button>
                    <Dropdown style={{ margin: 'auto', float: 'inline-end' }}>
                      <Dropdown.Toggle
                        style={{ fontSize: '10px' }}
                        variant="success"
                        id="dropdown-basic"
                      >
                        Filter Product
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        style={{
                          width: '20rem',
                          padding: '10px',
                          overflow: 'auto',
                          maxHeight: '250px',
                        }}
                      >
                        <div className="searchbox">
                          <input
                            type="text"
                            placeholder="Search..."
                            className="search"
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                        </div>
                        {unitSold
                          .filter(
                            (e) =>
                              !searchQuery ||
                              (e.item &&
                                e.item.toLowerCase().includes(searchQuery.toLowerCase() || '')),
                          )
                          .map((item, index) => (
                            <Form.Check
                              type="checkbox"
                              key={index}
                              id={`checkbox-${index}`}
                              label={item.item}
                              checked={selectedItems.includes(item.item)}
                              onChange={() => handleDropdownChange(item.item)}
                            />
                          ))}
                      </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown style={{ margin: 'auto', paddingRight: '2px', float: 'inline-end' }}>
                      <Dropdown.Toggle
                        style={{ fontSize: '10px' }}
                        variant="success"
                        id="dropdown-basic"
                      >
                        Filter Location
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        style={{
                          padding: '10px',
                          overflow: 'auto',
                          maxHeight: '250px',
                        }}
                      >
                        <div className="searchbox"></div>
                        <Form.Check
                          type="checkbox"
                          label="Website"
                          checked={selectedItems.includes('Website')}
                          onChange={() => handleDropdownChange('Website')}
                        />
                        <Form.Check
                          type="checkbox"
                          label="Butik"
                          checked={selectedItems.includes('Butik')}
                          onChange={() => handleDropdownChange('Butik')}
                        />
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <Table striped bordered hover className="table">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Sku</th>
                        <th>Unit Sold</th>
                        <th>Total Sale</th>
                        <th onClick={handleFilter} style={{ cursor: 'pointer' }}>
                          Location {filterLocation}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedItems.length === 0 ? (
                        unitSold
                          .sort((a, b) => {
                            if (filterLocation === '↑') return a.location.localeCompare(b.location);
                            if (filterLocation === '↓') return b.location.localeCompare(a.location);
                            return 0;
                          })
                          .map((value, index) => (
                            <tr key={index}>
                              <td>{value.item}</td>
                              <td>{value.sku}</td>
                              <td>{value.unit}</td>
                              <td>{'RM ' + Math.round((value.totalSale * 100) / 100)}</td>
                              <td>{value.location}</td>
                            </tr>
                          ))
                      ) : selectedItems.length > 0 ? (
                        unitSold
                          .filter(
                            (e) =>
                              selectedItems.includes(e.item) || selectedItems.includes(e.location),
                          )
                          .sort((a, b) => {
                            if (filterLocation === '↑') return a.location.localeCompare(b.location);
                            if (filterLocation === '↓') return b.location.localeCompare(a.location);
                            return 0;
                          })
                          .map((value, index) => (
                            <tr key={index}>
                              <td>{value.item}</td>
                              <td>{value.sku}</td>
                              <td>{value.unit}</td>
                              <td>{'RM ' + Math.round((value.totalSale * 100) / 100)}</td>
                              <td>{value.location}</td>
                            </tr>
                          ))
                      ) : selectedItems.length === 0 && unitSold.length <= 0 ? (
                        <tr>
                          <td colSpan={4}>{'No data'}</td>
                        </tr>
                      ) : null}
                    </tbody>
                  </Table>
                </Card.Body>
                <div className="see-more-text" onClick={() => setOpenProductSold(false)}>
                  ❌
                </div>
              </Card>
            </div>
          ) : null}
          {/* table for srikandi top recruit */}
          {openSrikandiRecruit ? (
            <div ref={tableSrikandiRecruitCurrent} className="table-container">
              <Card>
                <Card.Body>
                  <Card.Title>Top Srikandi Recruiter</Card.Title>
                  <Table striped bordered hover className="table">
                    <thead>
                      <tr>
                        <th>Coupon</th>
                        <th>Name</th>
                        <th>Total Recruit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {srikandiRecruit.length > 0 ? (
                        srikandiRecruit.map((value, index) => (
                          <tr key={index}>
                            <td>{value.srikandiId}</td>
                            <td>{value.srikandiName}</td>
                            <td>{value.totalChildren}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={3}>{'No data'}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
                <div className="see-more-text" onClick={() => setOpenSrikandiRecruit(false)}>
                  ❌
                </div>
              </Card>
            </div>
          ) : null}
          <br></br>
          <br></br>
        </div>
      ) : null}
    </Container>
  );
};
